/**
 * Formater dato til norsk DD.MM.YYYY.
 * Aksepterer ISO-strenger ("2026-01-15", "2026-01-15T10:30:00Z"), Date, eller null/undefined.
 * Returnerer "—" for tomme verdier.
 */
export function fmtDateNo(value) {
  if (value === null || value === undefined || value === '' || value === '—') return '—';
  try {
    let s = String(value);
    if (s.includes('T')) s = s.split('T')[0];
    // Allerede DD.MM.YYYY?
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(s)) return s;
    // Forvent YYYY-MM-DD
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}.${m[2]}.${m[1]}`;
    // Fallback: Date parse
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      return `${dd}.${mm}.${d.getFullYear()}`;
    }
    return s;
  } catch {
    return String(value);
  }
}

export default fmtDateNo;
